import { render } from "./DatenschutzHinweis.vue?vue&type=template&id=05883dea"
import script from "./DatenschutzHinweis.vue?vue&type=script&lang=js"
export * from "./DatenschutzHinweis.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__